import {
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnDestroy,
    OnInit,
    Output,
    SimpleChanges
} from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import $ from 'jquery';
import { takeWhile } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { SelectItem } from '../../../shared';

@Component({
    selector: 'ef-sync-dialog-presenter',
    templateUrl: './sync-dialog-presenter.component.html',
    styleUrls: ['./sync-dialog-presenter.component.scss'],
    standalone: false
})
export class SyncDialogPresenterComponent
    implements OnInit, OnChanges, OnDestroy {
    @Input() FromPeriodSelectItems: SelectItem[];
    private _toPeriods: SelectItem[] = [];
    @Input() public set ToPeriodSelectItems(value: SelectItem[]) {
        this._toPeriods = value;
    }
    public get ToPeriodSelectItems(): SelectItem[] {
        return this._toPeriods.map(item => {
            return {
                label: item.label,
                value: item.value,
                disabled:
                    this.syncFormGroup.controls['FromPeriod'].value ===
                    item.value
            };
        });
    }
    @Output() onCancel: EventEmitter<any> = new EventEmitter();
    @Output() onOk: EventEmitter<any> = new EventEmitter();
    dropdownItemHeight = environment.dropdownItemHeight;
    syncFormGroup: UntypedFormGroup;
    private active = true;
    constructor() {
        this.syncFormGroup = new UntypedFormGroup({
            FromPeriod: new UntypedFormControl(null),
            ToPeriod: new UntypedFormControl(null, Validators.required),
            syncType: new UntypedFormControl('Quickbooks')
        });
    }

    ngOnInit(): void {
        const controls = this.syncFormGroup.controls;
        controls['syncType'].valueChanges
            .pipe(takeWhile(() => this.active))
            .subscribe(value => {
                switch (value) {
                    case 'Quickbooks':
                        $('.p-dialog-title').text('Sync with current rates');
                        controls['FromPeriod'].setValidators(null);
                        break;
                    case 'Session':
                        $('.p-dialog-title').text('Sync with Processed Period');
                        controls['FromPeriod'].setValidators(
                            Validators.required
                        );
                        controls['ToPeriod'].setValue(null);
                        break;
                    default:
                }
            });
        controls['FromPeriod'].valueChanges
            .pipe(takeWhile(() => this.active))
            .subscribe(value => {
                if (controls['ToPeriod'].value === value) {
                    controls['ToPeriod'].setValue(null);
                }
            });
    }
    ngOnChanges(changes: SimpleChanges): void {
        if (changes && changes.SyncType && changes.SyncType.currentValue) {
            this.syncFormGroup
                .get('syncType')
                .setValue(changes.SyncType.currentValue);
        }
    }
    ngOnDestroy(): void {
        this.active = false;
    }

    setSyncType(syncType: 'Quickbooks' | 'Session'): void {
        if (this.syncFormGroup.controls['syncType'].value !== syncType) {
            this.syncFormGroup.controls['syncType'].setValue(syncType);
        }
    }

    isSyncType(syncType: 'Quickbooks' | 'Session'): boolean {
        return this.syncFormGroup.controls['syncType'].value === syncType;
    }
}
